"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Car, Shield, Clock, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
const services = [{
  id: 1,
  icon: Car,
  title: "Luxury Black Car Service",
  description: "Premium sedans with professional chauffeurs for business executives and VIP clients seeking ultimate comfort and style.",
  link: "/ServicesPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_sedan_interior.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_sedan_interior.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_sedan_interior.png-wvc-sizes"
}, {
  id: 2,
  icon: Shield,
  title: "SUV Chauffeur Service",
  description: "Spacious, high-end SUVs perfect for groups, families, or clients requiring extra luggage capacity and privacy.",
  link: "/ServicesPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/premium_suv_exterior.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/premium_suv_exterior.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/premium_suv_exterior.png-wvc-sizes"
}, {
  id: 3,
  icon: Clock,
  title: "Airport & Event Transfers",
  description: "Punctual transfers for flights, corporate events, and special occasions with 24/7 availability across Los Angeles.",
  link: "/ServicesPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/lax_airport_chauffeur.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/lax_airport_chauffeur.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/lax_airport_chauffeur.png-wvc-sizes"
}];
export default function OurServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={ref} className="section-padding bg-background overflow-hidden" id="services-overview">
      <div className="container mx-auto px-4 md:px-6">
        <div className={cn("max-w-3xl mb-12 md:mb-20 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-primary text-sm font-bold uppercase tracking-[0.2em] mb-4">
            Our Expertise
          </h2>
          <h3 className="text-4xl md:text-5xl font-display text-foreground mb-6">
            Premium Transportation Solutions in Los Angeles
          </h3>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl">
            Experience the pinnacle of professional chauffeur services. Whether it's a high-stakes business meeting or a seamless airport transfer, we ensure every journey is defined by luxury and precision.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => <Card key={service.id} data-index={index} className={cn("card border-none p-0 overflow-hidden group transition-all duration-700 delay-[200ms]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
              <div className="relative h-64 overflow-hidden">
                <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-primary-dark/20 group-hover:bg-primary-dark/10 transition-colors duration-300" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm p-3 rounded-md shadow-soft">
                  <service.icon className="w-6 h-6 text-primary" strokeWidth={2} />
                </div>
              </div>
              
              <CardHeader className="pt-6">
                <CardTitle className="text-2xl font-display text-foreground group-hover:text-primary transition-colors">
                  {service.title}
                </CardTitle>
                <CardDescription className="text-muted-foreground font-sans leading-relaxed mt-2">
                  {service.description}
                </CardDescription>
              </CardHeader>

              <CardContent className="pb-8 mt-auto">
                <Link to={service.link} className="block">
                  <Button variant="outline" className="btn-secondary w-full group/btn">
                    Explore Service
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                  </Button>
                </Link>
              </CardContent>
            </Card>)}
        </div>

        <div className={cn("mt-16 text-center transition-all duration-700 delay-500", isVisible ? "opacity-100" : "opacity-0")}>
          <Link to="/ServicesPage">
            <Button className="btn-primary">
              View All Services
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}